<!--
 * @Author: your name
 * @Date: 2020-03-13 16:31:00
 * @LastEditTime: 2020-11-05 19:30:10
 * @LastEditors: OBKoro1
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Apply.vue
 -->
<template>
  <div class="BaomingSuccess">
        <div class="content">
             <!-- 关于username 与 path的值 参考官方文档  -->
          <wx-open-launch-app
            id="test"
            username="gh_3af6a43b1571"
            path="pages/demo2/onlin_study/index.html"
            @error="handleErrorFn"
            @launch="handleLaunchFn"
          >
           <div class="qrcode" @click="test2()">
                <img :src="qrcode" class="qrcodeImg">
            </div>

            <div class="qrcode" @click="test3()">
                h5 内部跳小程序页面
            </div>
         <!-- 由于是vue框架，需要把template标签转换为script标签避免和vue的tempalte报错 -->
        <script type="text/wxtag-template">
                <style>
                    .label {
                        color: #448ce1;
                        font-size: 15px;
                        display:block;
                        text-align:center;
                         margin-top: 10px;
                        }
                </style>
            <div class="label">跳转小程序</div>
            <div>测试99000000</div>
        </script>
          </wx-open-launch-app>

          <div id="launch" class="launch"></div>
        
            </div>
  </div>
</template>

<script>
import { Http } from "@/utils/http.js";
import api from "@/config/api.js";
import Cookies from "js-cookie";
import axios from "axios";

import wx from 'weixin-js-sdk'
// import VConsole from 'vconsole'
export default {
  name: 'H5toWeapp',
  data() {
    return {
      qrcode: "http://wsl-cdn.medmeet.com.cn/1603700858520",
      meetid: 1001, // 会议ID
      show: false,
    };
  },
  created: function() {
     //return 
     let data = {}
     Http.post(api.getWechatJssdk, data).then(response => {
            wx.config({
                debug: false,
                appId: response.data.appId,
                timestamp: parseInt(response.data.timestamp),
                nonceStr: response.data.nonceStr,
                signature: response.data.signature,
                jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'chooseImage',
                    'scanQRCode',
                    'previewImage',
                    'miniProgram'
                ],
                // 其它配置不变， openTagList配置可使用的开放标签, 
                openTagList: ['wx-open-launch-weapp']
            })
            wx.ready(function() {
                console.log('ready')
                wx.onMenuShareAppMessage({
                    title: '星空学院',
                    desc: '星空学院',
                    link: location.href,
                    imgUrl: 'http://wsl-cdn.medmeet.com.cn/1586483912116',
                    success: function () {
                       // alert("分享成功");
                    }
                });
                // 分享到朋友圈
                wx.onMenuShareTimeline({
                    title: '星空学院',
                    link: location.href,
                    imgUrl: 'http://wsl-cdn.medmeet.com.cn/1586483912116',
                    success: function () {
                        //alert("分享成功");
                    }
                });


            }),
          wx.error(function(err) {
            console.log('错误--11')
            console.log(err)  
            console.log('错误--22')
          })
    }) 
  },

  methods: {
     handleLaunchFn(e) {
      console.log("success", e);
    },
    handleErrorFn(e) {
      console.log("fail", e.detail);
    },
    test3(){
      console.log(8888)
      return 
      var that = this
        wx.previewImage({
          current: that.qrcode, // 当前显示图片的http链接
          urls: [that.qrcode] // 需要预览的图片http链接列表
        });
    },
    test2(){
      console.log('跳--111')
      wx.miniProgram.navigateTo({
          url: '/pages/demo2/onlin_study/index',
      });
      console.log('跳--222')
      return 
    }

  },
  mounted: function() {
    		// 引入调试工具
		// new VConsole()
    let script = document.createElement('script')
    script.type = 'text/wxtag-template';
    script.text = `<div>点击打开00</div>`
    let html = `<wx-open-launch-weapp username="gh_3af6a43b1571" path="pages/demo2/onlin_study/index.html  @error="handleErrorFn"
            @launch="handleLaunchFn"">
             ${script.outerHTML}
                </wx-open-launch-weapp>`
    let id = "launch"
    //document.getElementsByClassName(id)[0].innerHTML = html;
  },
};
</script>

<style lang="less">
.BaomingSuccess {
  font-size: 16px;
    display: flex;
    flex-direction: column;
   //  background-color: #041d34;
      min-height: 100vh;
     .sub-logo2 {
        position: absolute;
        width: 40px;
        top: 20px;
        left: 20px;    
    }
  .content {
    position: relative;
     min-height: 100vh;
    .top {
         margin: 52px auto 0;
         width: 80%;
        .topImg {
            width: 100%;
        }
    }
    .qrcode {
         margin: 0 auto;
         width: 50%;
        .qrcodeImg {
            width: 100%;
        }
    }
    .tip {
         margin: 0 auto;
          width: 64%;
        .tipImg {
            width: 100%;
        }
    }

    .bottom {
        margin-top: 12px;
        position: absolute;
        bottom: 0px;
        .bottomImg {
            width: 100%;
        }
    }
    .registered {
        border-radius: 4px;
        box-sizing: border-box;
        padding: 0 20px;
        width: 90%;
        margin: auto;
        .title{
          margin-top: 20px;
          margin-bottom: 28px;
          font-size: 20px;
          text-align: center;
          height: 20px;
          line-height: 20px;
          color: #028fe1;
        }
        .van-cell {
          align-items: center;
          border-bottom: 1px solid #dcdcdc;
          font-size: 14px;
          margin-top: 10px;
        }
        .bottom {
            margin-top: 30px;
            margin-bottom: 30px;
            .confirm {
              width: 120px;
              height: 40px;
              border-radius: 4px;
              font-size: 18px;
            }
        }
    }
  }
   .qrcode2 {
         margin: 0 auto;
         width: 100%;
        .qrcodeImg {
            width: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/H5toWeapp.vue